import React from 'react'
import { Outlet } from 'react-router'

import type { EmptyLayoutProps } from './EmptyLayout.props'

export function EmptyLayout({ ...props }: EmptyLayoutProps) {
  return (
    <div className="empty-layout">
      <Outlet />
    </div>
  )
}
